/**
 * 工單彙總轉倉 create／update payload（camel）。
 * 禁止：`sourceType`／`sourceId`（後端固定 WORK_ORDER／null）。
 * Line 可選 unitId（有值才帶）。
 */

export function buildWorkOrderStockTransferCreatePayload(values) {
  return buildWorkOrderStockTransferWritePayload(values);
}

export function buildWorkOrderStockTransferUpdatePayload(values) {
  const updatedAt = values?.updatedAt ?? values?.record?.updatedAt ?? null;
  return buildWorkOrderStockTransferWritePayload(values, { updatedAt });
}

function buildWorkOrderStockTransferWritePayload(values, { updatedAt = null } = {}) {
  const payload = {
    transferDate: values?.transferDate ?? null,
    toWarehouseId: values?.toWarehouseId ?? null,
    issueReason: values?.issueReason ?? null,
    remark: values?.remark ?? null,
    lines: mapTransferLines(values?.lines),
  };

  if (updatedAt != null && updatedAt !== '') {
    payload.updatedAt = updatedAt;
  }

  return payload;
}

function mapTransferLines(lines = []) {
  return (lines ?? []).map((line) => {
    const mapped = {
      invStockId: line?.invStockId ?? null,
      qty: line?.qty === '' || line?.qty == null ? null : Number(line.qty),
      toLocationId: line?.toLocationId || null,
      stockNoPolicy: line?.stockNoPolicy || null,
      remark: line?.remark ?? null,
    };
    const unitId = String(line?.unitId ?? '').trim();
    if (unitId) {
      mapped.unitId = unitId;
    }
    return mapped;
  });
}
